import { ApiProviderMetadataInvitationStatusChoices, ProviderRoleEnums } from "@api/graphql/types-and-hooks";

export enum CaregiverAppStatus {
  NotInvited = "not_invited",
  CodeSent = "code_sent",
  Connected = "connected",
}

export enum CodeSentVia {
  Email = "email",
  Sms = "sms",
  Both = "both",
}

export type ProviderRole = "Admin" | "BCBA" | "Assessment BCBA" | "Evaluation Psychologist" | "Psychologist" | "RBT";

export interface MemberProvider {
  id: string;
  firstName: string;
  lastName: string;
  name: string;
  email: string;
  roles: ProviderRole[];
  roleEnums?: ProviderRoleEnums[];
  assignedClientsCount: number;
  portalStatus: ApiProviderMetadataInvitationStatusChoices | null;
  invitedDate?: string;
  activeSinceDate?: string;
  invitationUrl?: string;
  gender?: string;
  specifyGender?: string;
  clients: ProviderClient[];
  isFronteraInternal?: boolean;
  hasInternalEmail?: boolean;
}

interface ProviderClient {
  id: string;
  name: string;
  dateOfBirth: string;
  program: string;
}

export interface MemberCaregiver {
  id: string;
  firstName: string;
  lastName: string;
  name: string;
  email: string;
  phone: string;
  isPrimary: boolean;
  linkedChildren: LinkedChild[];
  activationCode: string;
  appStatus: CaregiverAppStatus;
  codeSentDate?: string;
  codeSentVia?: CodeSentVia;
  connectedDate?: string;
  assignedBcba: string;
}

export interface LinkedChild {
  id: string;
  name: string;
  dateOfBirth: string;
  assignedBcba: string;
  relationship: string;
}
